import { useState, useEffect } from "react";

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";
const PWD = process.env.REACT_APP_PASSWORD || "limedge2024";

function LoginScreen({ onLogin }) {
  const [pw, setPw] = useState("");
  const [err, setErr] = useState(false);
  const submit = (e) => {
    e.preventDefault();
    if (pw === PWD) { localStorage.setItem("lm_auth", "1"); onLogin(); }
    else { setErr(true); setTimeout(() => setErr(false), 1500); }
  };
  return (
    <div style={{
      minHeight: "100vh", background: Y,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "'Plus Jakarta Sans','DM Sans',system-ui,sans-serif",
    }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800;900&display=swap');*{box-sizing:border-box;margin:0;padding:0;}`}</style>
      <div style={{ textAlign: "center" }}>
        <div style={{
          width: 80, height: 80, borderRadius: 18, background: D,
          display: "flex", alignItems: "center", justifyContent: "center",
          margin: "0 auto 28px", boxShadow: "0 8px 32px rgba(0,0,0,0.18)"
        }}>
          <span style={{ fontSize: 15, fontWeight: 900, color: WHITE }}>
            thomkt<span style={{ color: Y }}>.</span>
          </span>
        </div>
        <div style={{ fontSize: 28, fontWeight: 900, color: D, marginBottom: 6, letterSpacing: -1 }}>Limedge</div>
        <div style={{ fontSize: 13, color: "rgba(30,30,30,0.55)", marginBottom: 32, fontWeight: 600 }}>Dashboard · thomkt solutions</div>
        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 12, width: 280 }}>
          <input
            type="password" placeholder="Password" value={pw}
            onChange={e => setPw(e.target.value)} autoFocus
            style={{
              padding: "14px 18px", borderRadius: 14, border: `2px solid ${err ? "#e53e3e" : "transparent"}`,
              fontSize: 14, fontWeight: 600, outline: "none", background: WHITE,
              transition: "border 0.2s", color: D,
            }}
          />
          <button type="submit" style={{
            padding: "14px", borderRadius: 14, background: D, color: WHITE,
            fontSize: 14, fontWeight: 800, border: "none", cursor: "pointer",
            transition: "opacity 0.2s",
          }}>Enter</button>
        </form>
        {err && <div style={{ marginTop: 12, fontSize: 12, color: "#b91c1c", fontWeight: 700 }}>Wrong password</div>}
      </div>
    </div>
  );
}

const Y = "#CCFF00";
const YL = "#f4ffe0";
const D = "#1e1e1e";
const SUB = "#999";
const BORDER = "#ebebeb";
const WHITE = "#ffffff";

function DonutRing({ pct = 72, size = 130, stroke = 10 }) {
  const total = 48;
  const r = (size - stroke * 2) / 2;
  const cx = size / 2, cy = size / 2;
  return (
    <svg width={size} height={size} style={{ display: "block" }}>
      {Array.from({ length: total }).map((_, i) => {
        const a = (i / total) * 360 - 90;
        const rad = a * Math.PI / 180;
        const active = (i / total) < (pct / 100);
        const x1 = cx + (r - 4) * Math.cos(rad);
        const y1 = cy + (r - 4) * Math.sin(rad);
        const x2 = cx + (r + 4) * Math.cos(rad);
        const y2 = cy + (r + 4) * Math.sin(rad);
        return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2}
          stroke={active ? Y : "#e8e8e8"} strokeWidth={2.5} strokeLinecap="round" />;
      })}
      <circle cx={cx} cy={cy} r={r - 14} fill={WHITE} />
    </svg>
  );
}

function Card({ children, style = {} }) {
  return (
    <div style={{
      background: WHITE, borderRadius: 20,
      boxShadow: "0 2px 18px rgba(0,0,0,0.06)",
      overflow: "hidden", ...style
    }}>{children}</div>
  );
}

function ArrowBtn({ href }) {
  return (
    <button onClick={() => href && window.open(href, "_blank")} style={{
      width: 28, height: 28, borderRadius: "50%",
      background: "#f5f5f5", border: "none", cursor: "pointer",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: 12, color: SUB
    }}>↗</button>
  );
}

const days = ["S", "M", "T", "W", "T", "F", "S"];
const calDays = [
  { d: "Mon", n: "22" }, { d: "Tue", n: "23" },
  { d: "Wed", n: "24", active: true },
  { d: "Thu", n: "25" }, { d: "Fri", n: "26" }, { d: "Sat", n: "27" },
];
const times = ["8:00 am", "9:00 am", "10:00 am", "11:00 am"];

const GHL = `https://app.gohighlevel.com/v2/location/jiVU2qLlFhdD7S8civ19`;
const NAV_LINKS = {
  Clients: `${GHL}/contacts`,
  Automation: `${GHL}/automation/workflows`,
  Reports: `${GHL}/reporting/overview`,
  Calendar: `${GHL}/calendars/view`,
  Reviews: `${GHL}/reputation/overview`,
};

export default function App() {
  const [authed, setAuthed] = useState(!!localStorage.getItem("lm_auth"));
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [activeTab, setActiveTab] = useState("Dashboard");
  const [openAccordion, setOpenAccordion] = useState(null);
  const [showAppMenu, setShowAppMenu] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const fetchData = async () => {
    try {
      const r = await fetch(`${API}/api/summary`);
      const d = await r.json();
      setData(d);
      setLastUpdate(new Date().toLocaleTimeString());
      setError(null);
    } catch (e) {
      setError("Backend offline — rode npm run dev");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!authed) return;
    fetchData();
    const interval = setInterval(fetchData, 30000);
    return () => clearInterval(interval);
  }, [authed]);

  if (!authed) return <LoginScreen onLogin={() => setAuthed(true)} />;

  const leads = data?.leads || 0;
  const booked = data?.booked || 0;
  const revenue = data?.revenue || 0;
  const recentLeads = data?.recentLeads || [];
  const recentOpps = data?.recentOpportunities || [];

  // Gera weekly simulado baseado no total real
  const weekly = leads > 0
    ? [
      Math.floor(leads * 0.12), Math.floor(leads * 0.19),
      Math.floor(leads * 0.08), Math.floor(leads * 0.20),
      Math.floor(leads * 0.14), Math.floor(leads * 0.18),
      leads - Math.floor(leads * 0.91)
    ]
    : [0, 0, 0, 0, 0, 0, 0];
  const maxBar = Math.max(...weekly, 1);
  const captureRate = leads > 0 ? Math.min(Math.round((booked / leads) * 100), 100) : 0;


  return (
    <div style={{
      background: `linear-gradient(115deg, #fafaf8 0%, #fafaf8 40%, #fef9dc 100%)`,
      minHeight: "100vh",
      fontFamily: "'Plus Jakarta Sans','DM Sans',system-ui,sans-serif",
      color: D,
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800;900&display=swap');
        * { box-sizing:border-box; margin:0; padding:0; }
        button { cursor:pointer; border:none; background:none; font-family:inherit; }
      `}</style>

      {/* NAV */}
      <div style={{
        display: "flex", alignItems: "center", padding: "18px 28px", gap: 8,
        background: WHITE, boxShadow: "0 1px 0 #ebebeb"
      }}>
        <div style={{
          border: `1.5px solid ${BORDER}`, borderRadius: 24,
          padding: "7px 18px", fontSize: 14, fontWeight: 800, marginRight: 16
        }}>Limedge</div>
        {["Dashboard", "Clients", "Automation", "Reports", "Calendar", "Reviews"].map((item) => (
          <button key={item} onClick={() => {
            if (item === "Dashboard") { setActiveTab("Dashboard"); }
            else { window.open(NAV_LINKS[item], "_blank"); }
          }} style={{
            padding: "8px 16px", borderRadius: 22,
            background: activeTab === item ? D : "transparent",
            color: activeTab === item ? WHITE : SUB,
            fontSize: 12, fontWeight: 600,
          }}>{item}</button>
        ))}
        <div style={{ flex: 1 }} />
        {lastUpdate && (
          <span style={{ fontSize: 10, color: SUB }}>Updated {lastUpdate}</span>
        )}
        <button onClick={() => window.open(`${GHL}/settings/company`, "_blank")} style={{
          display: "flex", alignItems: "center", gap: 6,
          background: "#f5f5f5", borderRadius: 22, padding: "8px 16px",
          fontSize: 12, fontWeight: 600,
        }}>⚙️ Settings</button>
        <button onClick={() => window.open(`${GHL}/conversations`, "_blank")} style={{
          width: 36, height: 36, borderRadius: "50%", background: "#f5f5f5",
          display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15
        }}>🔔</button>
        <div style={{ position: "relative" }}>
          <button onClick={() => setShowProfileMenu(v => !v)} style={{
            width: 36, height: 36, borderRadius: "50%", background: "#f5f5f5",
            display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15
          }}>👤</button>
          {showProfileMenu && (
            <div style={{
              position: "absolute", right: 0, top: 44, background: WHITE,
              borderRadius: 12, boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
              border: `1px solid ${BORDER}`, minWidth: 140, zIndex: 100, overflow: "hidden"
            }}>
              <button onClick={() => { window.open(`${GHL}/settings/profile`, "_blank"); setShowProfileMenu(false); }} style={{
                display: "block", width: "100%", padding: "12px 16px", fontSize: 12,
                fontWeight: 600, textAlign: "left", color: D, background: "transparent",
              }}>👤 Profile</button>
              <button onClick={() => { localStorage.removeItem("lm_auth"); setAuthed(false); setShowProfileMenu(false); }} style={{
                display: "block", width: "100%", padding: "12px 16px", fontSize: 12,
                fontWeight: 600, textAlign: "left", color: "#e53e3e", background: "transparent",
                borderTop: `1px solid ${BORDER}`
              }}>🚪 Logout</button>
            </div>
          )}
        </div>
      </div>

      {loading ? (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "60vh", flexDirection: "column", gap: 16 }}>
          <div style={{ fontSize: 32 }}>🍋</div>
          <div style={{ fontSize: 14, color: SUB }}>Conectando ao GHL...</div>
        </div>
      ) : error ? (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "60vh", flexDirection: "column", gap: 12 }}>
          <div style={{ fontSize: 32 }}>⚠️</div>
          <div style={{ fontSize: 14, color: "#e53e3e", fontWeight: 600 }}>{error}</div>
          <button onClick={fetchData} style={{
            background: D, color: WHITE, padding: "10px 24px",
            borderRadius: 22, fontSize: 12, fontWeight: 700, cursor: "pointer"
          }}>Tentar novamente</button>
        </div>
      ) : (
        <div style={{ padding: "28px 28px 60px" }}>

          {/* WELCOME */}
          <div style={{ fontSize: 38, fontWeight: 800, letterSpacing: -1, marginBottom: 20 }}>
            Welcome, Flavio
          </div>

          {/* PILLS ROW */}
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 28, flexWrap: "wrap" }}>
            <div style={{ background: D, color: WHITE, borderRadius: 22, padding: "8px 18px", fontSize: 12, fontWeight: 700 }}>
              {leads} Leads
            </div>
            <div style={{ background: Y, color: D, borderRadius: 22, padding: "8px 18px", fontSize: 12, fontWeight: 700 }}>
              {booked} Booked
            </div>
            <div style={{
              background: `repeating-linear-gradient(45deg,#e8e8e8 0px,#e8e8e8 2px,#f5f5f5 2px,#f5f5f5 10px)`,
              borderRadius: 22, padding: "8px 28px", fontSize: 12, fontWeight: 600, color: "#aaa", flex: 1, maxWidth: 240
            }}>Pipeline Active</div>
            <div style={{ border: `1.5px solid ${BORDER}`, borderRadius: 22, padding: "8px 18px", fontSize: 12, fontWeight: 600, color: SUB }}>
              ${revenue.toLocaleString()} Revenue
            </div>
            <div style={{ flex: 1 }} />
            {[
              { icon: "👤", val: leads, label: "Leads" },
              { icon: "📅", val: booked, label: "Booked" },
              { icon: "⭐", val: recentOpps.length, label: "Opps" },
            ].map((s, i) => (
              <div key={i} style={{ display: "flex", alignItems: "flex-end", gap: 4 }}>
                <span style={{ fontSize: 11, color: SUB, paddingBottom: 4 }}>{s.icon}</span>
                <div>
                  <div style={{ fontSize: 32, fontWeight: 900, letterSpacing: -1, lineHeight: 1 }}>{s.val}</div>
                  <div style={{ fontSize: 10, color: SUB, fontWeight: 600 }}>{s.label}</div>
                </div>
              </div>
            ))}
          </div>

          {/* MAIN GRID */}
          <div style={{ display: "grid", gridTemplateColumns: "260px 1fr 1fr 1fr", gridTemplateRows: "auto auto", gap: 16 }}>

            {/* COL 1 — PROFILE + ACCORDION */}
            <Card style={{ gridColumn: "1", gridRow: "1 / 3", padding: 0 }}>
              <div style={{
                background: `linear-gradient(160deg, #e8e8e0 0%, #d8d8c8 100%)`,
                height: 260, display: "flex", flexDirection: "column",
                justifyContent: "flex-end", padding: "18px 18px 14px", position: "relative"
              }}>
                <div style={{
                  position: "absolute", top: "50%", left: "50%",
                  transform: "translate(-50%, -60%)",
                  width: 90, height: 90, borderRadius: 20, background: Y,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.22)",
                  overflow: "hidden",
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                  <svg viewBox="0 0 90 90" width="90" height="90" style={{ display: "block" }}>
                    <rect width="90" height="90" fill={Y} />
                    {/* thomkt. wordmark */}
                    <text x="8" y="56" fontFamily="'Plus Jakarta Sans',system-ui,sans-serif"
                      fontWeight="900" fontSize="22" fill="#1e1e1e" letterSpacing="-1">thomkt.</text>
                    {/* ATX / ESTD 2022 / AGENCY badge */}
                    <text x="66" y="36" fontFamily="'Plus Jakarta Sans',system-ui,sans-serif"
                      fontWeight="800" fontSize="5.5" fill="#1e1e1e" textAnchor="middle">ATX</text>
                    <text x="66" y="43" fontFamily="'Plus Jakarta Sans',system-ui,sans-serif"
                      fontWeight="800" fontSize="5.5" fill="#1e1e1e" textAnchor="middle">ESTD 2022</text>
                    <text x="66" y="50" fontFamily="'Plus Jakarta Sans',system-ui,sans-serif"
                      fontWeight="800" fontSize="5.5" fill="#1e1e1e" textAnchor="middle">AGENCY</text>
                  </svg>
                </div>
                <div style={{ background: "linear-gradient(0deg,rgba(0,0,0,0.55) 0%,transparent 100%)", position: "absolute", inset: 0 }} />
                <div style={{ position: "relative", zIndex: 1 }}>
                  <div style={{ fontSize: 16, fontWeight: 800, color: WHITE }}>thomkt.</div>
                  <div style={{ fontSize: 11, color: "rgba(255,255,255,0.7)" }}>
                    {revenue >= 997 ? "Full" : revenue >= 697 ? "Pro" : "Starter"} · Austin, TX
                  </div>
                </div>
                <button style={{
                  position: "absolute", right: 16, bottom: 14, zIndex: 1,
                  background: "rgba(255,255,255,0.92)", borderRadius: 22,
                  padding: "8px 16px", fontSize: 12, fontWeight: 800, color: D,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                }}>${revenue >= 997 ? "997" : revenue >= 697 ? "697" : "397"}/mo</button>
              </div>

              {[
                { label: "Automation Status", content: `${recentOpps.length} active opportunities · Workflow published` },
                { label: "Active Modules", content: "Capture · Nurture · Book · Survey · Notify" },
                { label: "Billing Summary", content: `$${revenue >= 997 ? "997" : revenue >= 697 ? "697" : "397"}/mo · Pro Plan` },
                { label: "Client Settings", link: `${GHL}/settings/company` },
              ].map((item, i) => (
                <div key={i}>
                  <button onClick={() => {
                    if (item.link) { window.open(item.link, "_blank"); return; }
                    setOpenAccordion(openAccordion === i ? null : i);
                  }} style={{
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                    padding: "15px 20px", borderTop: `1px dashed ${BORDER}`,
                    width: "100%", background: "transparent", textAlign: "left"
                  }}>
                    <span style={{ fontSize: 13, fontWeight: 600 }}>{item.label}</span>
                    <span style={{ color: SUB, fontSize: 13 }}>{openAccordion === i ? "∧" : "∨"}</span>
                  </button>
                  {openAccordion === i && item.content && (
                    <div style={{ padding: "0 20px 14px", fontSize: 11, color: SUB, fontWeight: 500 }}>
                      {item.content}
                    </div>
                  )}
                </div>
              ))}

              <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "14px 20px", borderTop: `1px dashed ${BORDER}`, position: "relative" }}>
                <div style={{
                  width: 40, height: 40, borderRadius: 10, background: "#f0f0f0",
                  display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18
                }}>📱</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 12, fontWeight: 700 }}>Limedge App</div>
                  <div style={{ fontSize: 10, color: SUB }}>Version 1.0</div>
                </div>
                <div style={{ position: "relative" }}>
                  <button onClick={() => setShowAppMenu(v => !v)} style={{ fontSize: 16, color: SUB, padding: "4px 8px" }}>···</button>
                  {showAppMenu && (
                    <div style={{
                      position: "absolute", right: 0, bottom: 36, background: WHITE,
                      borderRadius: 12, boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
                      border: `1px solid ${BORDER}`, minWidth: 160, zIndex: 100, overflow: "hidden"
                    }}>
                      <button onClick={() => { window.open(`${GHL}/contacts`, "_blank"); setShowAppMenu(false); }} style={{
                        display: "block", width: "100%", padding: "12px 16px", fontSize: 12,
                        fontWeight: 600, textAlign: "left", color: D, background: "transparent",
                      }}>👥 Open Contacts</button>
                      <button onClick={() => { window.open(`${GHL}/automation/workflows`, "_blank"); setShowAppMenu(false); }} style={{
                        display: "block", width: "100%", padding: "12px 16px", fontSize: 12,
                        fontWeight: 600, textAlign: "left", color: D, background: "transparent",
                        borderTop: `1px solid ${BORDER}`
                      }}>⚡ Workflows</button>
                      <button onClick={() => { localStorage.removeItem("lm_auth"); setAuthed(false); setShowAppMenu(false); }} style={{
                        display: "block", width: "100%", padding: "12px 16px", fontSize: 12,
                        fontWeight: 600, textAlign: "left", color: "#e53e3e", background: "transparent",
                        borderTop: `1px solid ${BORDER}`
                      }}>🚪 Logout</button>
                    </div>
                  )}
                </div>
              </div>
            </Card>

            {/* COL 2 — CHART */}
            <Card style={{ gridColumn: "2", gridRow: "1", padding: "22px 22px 18px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                <span style={{ fontSize: 15, fontWeight: 700 }}>Progress</span>
                <ArrowBtn href={`${GHL}/contacts`} />
              </div>
              <div style={{ display: "flex", alignItems: "flex-end", gap: 6, marginBottom: 20 }}>
                <span style={{ fontSize: 32, fontWeight: 900, letterSpacing: -1 }}>{leads}</span>
                <div style={{ paddingBottom: 4 }}>
                  <div style={{ fontSize: 10, fontWeight: 600, color: D }}>Leads</div>
                  <div style={{ fontSize: 10, color: SUB }}>this week</div>
                </div>
              </div>
              <div style={{ position: "relative", height: 110, display: "flex", alignItems: "flex-end", gap: 5 }}>
                {weekly.map((v, i) => {
                  const h = Math.max((v / maxBar) * 85, 4);
                  const isPeak = i === weekly.indexOf(Math.max(...weekly));
                  return (
                    <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
                      {isPeak && (
                        <div style={{
                          background: Y, color: D, fontSize: 8, fontWeight: 800,
                          padding: "2px 6px", borderRadius: 8, marginBottom: 4, whiteSpace: "nowrap"
                        }}>{v} leads</div>
                      )}
                      <div style={{
                        width: "70%", height: `${h}px`,
                        background: isPeak ? Y : "#e8e8e8",
                        borderRadius: "4px 4px 0 0", transition: "height 0.4s"
                      }} />
                    </div>
                  );
                })}
              </div>
              <div style={{ display: "flex", gap: 5, marginTop: 6 }}>
                {weekly.map((_, i) => (
                  <div key={i} style={{ flex: 1, display: "flex", justifyContent: "center" }}>
                    <div style={{ width: 5, height: 5, borderRadius: "50%", background: "#ddd" }} />
                  </div>
                ))}
              </div>
              <div style={{ display: "flex", gap: 5, marginTop: 4 }}>
                {days.map((d, i) => (
                  <div key={i} style={{ flex: 1, textAlign: "center", fontSize: 9, color: SUB, fontWeight: 600 }}>{d}</div>
                ))}
              </div>
            </Card>

            {/* COL 3 — RING */}
            <Card style={{ gridColumn: "3", gridRow: "1", padding: "22px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                <span style={{ fontSize: 15, fontWeight: 700 }}>Capture Rate</span>
                <ArrowBtn href={`${GHL}/calendars/appointments`} />
              </div>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", position: "relative", margin: "8px 0" }}>
                <DonutRing pct={captureRate} size={140} />
                <div style={{
                  position: "absolute", display: "flex", flexDirection: "column",
                  alignItems: "center", justifyContent: "center"
                }}>
                  <span style={{ fontSize: 26, fontWeight: 900, letterSpacing: -1 }}>{captureRate}%</span>
                  <span style={{ fontSize: 10, color: SUB, fontWeight: 600 }}>Booked/Leads</span>
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "center", gap: 10, marginTop: 12 }}>
                {[
                  { icon: "▶", title: "Open Workflows", url: `${GHL}/automation/workflows` },
                  { icon: "⏸", title: "Open Contacts", url: `${GHL}/contacts` },
                  { icon: "⏰", title: "Open Calendar", url: `${GHL}/calendars/view` },
                ].map((btn, i) => (
                  <button key={i} title={btn.title} onClick={() => window.open(btn.url, "_blank")} style={{
                    width: 40, height: 40, borderRadius: "50%",
                    border: i < 2 ? `1.5px solid ${BORDER}` : "none",
                    background: i === 2 ? D : "transparent",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 14, color: i === 2 ? WHITE : D
                  }}>{btn.icon}</button>
                ))}
              </div>
            </Card>

            {/* COL 4 — PIPELINE TASKS */}
            <div style={{ gridColumn: "4", gridRow: "1 / 3", display: "flex", flexDirection: "column" }}>
              <Card style={{ borderRadius: "20px 20px 0 0", padding: "20px 20px 16px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                  <span style={{ fontSize: 15, fontWeight: 700 }}>Pipeline</span>
                  <span style={{ fontSize: 28, fontWeight: 900, letterSpacing: -1 }}>
                    {leads > 0 ? Math.round((booked / leads) * 100) : 0}%
                  </span>
                </div>
                <div style={{ display: "flex", gap: 4, margin: "14px 0 4px", height: 36, alignItems: "flex-end" }}>
                  <div style={{ flex: 30, background: Y, borderRadius: "6px 6px 0 0", height: "100%", display: "flex", alignItems: "flex-end", padding: "0 8px 4px" }}>
                    <span style={{ fontSize: 10, fontWeight: 700 }}>Leads</span>
                  </div>
                  <div style={{ flex: 25, background: D, borderRadius: "6px 6px 0 0", height: "80%" }} />
                  <div style={{ flex: 10, background: "#d8d8d8", borderRadius: "6px 6px 0 0", height: "60%" }} />
                </div>
                <div style={{ display: "flex", gap: 4 }}>
                  <div style={{ flex: 30, fontSize: 9, color: SUB, fontWeight: 600 }}>{leads}</div>
                  <div style={{ flex: 25, fontSize: 9, color: SUB, fontWeight: 600 }}>{booked}</div>
                  <div style={{ flex: 10, fontSize: 9, color: SUB, fontWeight: 600 }}>0</div>
                </div>
              </Card>

              {/* Dark tasks */}
              <div style={{
                background: D, borderRadius: "0 0 20px 20px",
                flex: 1, padding: "18px",
                boxShadow: "0 2px 18px rgba(0,0,0,0.12)"
              }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                  <span style={{ fontSize: 14, fontWeight: 700, color: WHITE }}>Recent Leads</span>
                  <span style={{ fontSize: 18, fontWeight: 900, color: WHITE }}>{recentLeads.length}/5</span>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {recentLeads.length > 0 ? recentLeads.map((lead, i) => (
                    <div key={i} style={{
                      display: "flex", alignItems: "center", gap: 10,
                      padding: "11px 0",
                      borderBottom: i < recentLeads.length - 1 ? "1px solid #2a2a2a" : "none"
                    }}>
                      <div style={{
                        width: 32, height: 32, borderRadius: "50%",
                        background: "#2a2a2a", flexShrink: 0,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: 12, fontWeight: 800, color: Y
                      }}>{(lead.name || lead.phone || "?")[0].toUpperCase()}</div>
                      <div style={{ flex: 1, overflow: "hidden" }}>
                        <div style={{ fontSize: 12, fontWeight: 600, color: WHITE, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {lead.name || lead.phone || "Unknown"}
                        </div>
                        <div style={{ fontSize: 10, color: "#444", marginTop: 1 }}>
                          {new Date(lead.createdAt).toLocaleDateString()}
                        </div>
                      </div>
                      {lead.tags?.includes("new-prospect-received") && (
                        <div style={{
                          width: 18, height: 18, borderRadius: "50%",
                          background: Y, display: "flex",
                          alignItems: "center", justifyContent: "center", fontSize: 9, color: D
                        }}>✓</div>
                      )}
                    </div>
                  )) : (
                    <div style={{ color: "#444", fontSize: 12, textAlign: "center", padding: "20px 0" }}>
                      No leads yet
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* COL 1+2+3 ROW 2 — OPPORTUNITIES / CALENDAR */}
            <Card style={{ gridColumn: "1 / 4", gridRow: "2", padding: "22px 24px" }}>
              <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 16 }}>
                <span style={{ fontSize: 12, color: SUB, fontWeight: 600 }}>March</span>
                <span style={{ fontSize: 14, fontWeight: 800 }}>April 2026</span>
                <span style={{ fontSize: 12, color: SUB, fontWeight: 600 }}>May</span>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "60px repeat(6,1fr)", rowGap: 0 }}>
                <div />
                {calDays.map((d, i) => (
                  <div key={i} style={{ textAlign: "center", paddingBottom: 8 }}>
                    <div style={{ fontSize: 10, color: SUB, fontWeight: 600 }}>{d.d}</div>
                    <div style={{
                      fontSize: 13, fontWeight: d.active ? 900 : 600,
                      color: d.active ? D : "#ccc",
                      background: d.active ? YL : "transparent",
                      borderRadius: 6, display: "inline-block", padding: "2px 6px"
                    }}>{d.n}</div>
                  </div>
                ))}
                {times.map((time, row) => (
                  <>
                    <div key={`t-${row}`} style={{ fontSize: 10, color: "#ccc", fontWeight: 600, paddingTop: 8, paddingRight: 8, textAlign: "right" }}>{time}</div>
                    {calDays.map((_, col) => {
                      // Mostra oportunidades reais nos slots
                      const opp = row === 1 && col === 2 ? recentOpps[0] : row === 2 && col === 2 ? recentOpps[1] : null;
                      if (opp) return (
                        <div key={`opp-${col}`} style={{
                          gridColumn: `${col + 2} / span 2`,
                          background: D, borderRadius: 10,
                          padding: "8px 10px", margin: "2px 2px"
                        }}>
                          <div style={{ fontSize: 11, fontWeight: 700, color: WHITE, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {opp.name || "Opportunity"}
                          </div>
                          <div style={{ fontSize: 9, color: "#666", marginTop: 2 }}>
                            {opp.status} · ${opp.value || 0}
                          </div>
                        </div>
                      );
                      if (row === 1 && col === 3) return null;
                      return (
                        <div key={`cell-${row}-${col}`} style={{
                          height: 52, borderTop: `1px dashed ${BORDER}`,
                          borderRight: `1px dashed ${BORDER}`
                        }} />
                      );
                    })}
                  </>
                ))}
              </div>
            </Card>

          </div>

          <div style={{ textAlign: "center", marginTop: 28 }}>
            <span style={{ fontSize: 9, letterSpacing: 3, color: "#ccc", fontWeight: 600 }}>
              LIMEDGE · THOMKT SOLUTIONS LLC · limedge.com
            </span>
          </div>
        </div>
      )}
    </div>
  );
}